<template>
	<div class="ReChatMain"><!--:class="{'hideChat' : chatIsHidden}"-->
		<div class="chat_header card position-sticky">
			<div class="header_container">
				<div class="leftpart" >
					<base-button type="primary" class="no-border" simple icon @click="hideChat()">
						<i class="d-inline-block tim-ic ic-arrow-left"></i>
					</base-button>				

					<div class="chat_data" style="display: flex;"><!--ГРУППЫ И ЛЮДИ позже сделать отображение по if-->		
						<div class="chat-photo">
							<img :src="channelIcon" alt class="avatar" />
						</div>
						<div class="title_row">
							<div class="title"><i class="tim-icons icon-lock-circle text-primary"></i><p>{{title}}</p></div> 
							<div class="subtitle">
								<div class="ml-1 onlineStatus online"> <!--:class="[{'online':bOnlineStatus},{'offline':!bOnlineStatus}]"-->
									<i></i>
									<span class="subtitle mr-3">онлайн</span><!--{{strOnline}}--><!--отображать для Человека-->		
									<span class="subtitle">участников {{counter}}</span><!--отображать для Групп-->							
								</div>							
							</div>             
						</div>
					</div>

					<div class="favs" style="display: none;"><!--ЗАКЛАДКИ позже сделать отображение по if-->		
						<div class="title"><i class="tim-icons icon-book-bookmark text-primary mr-2 mt-1"></i><p>Закладки</p></div> 
					</div>
				</div>				

				<div class="chat_nav">
					<base-dropdown title-classes="btn btn-icon btn-simple btn-primary no-border"><!--позже сделать отображение по if, в Закладках меню не нужно-->	
						<template v-slot:title>
							<i class="d-inline-block tim-ic ic-menudot"></i>
						</template>

						<a class="dropdown-item">Отключить уведомления</a>
						<a class="dropdown-item">Посмотреть профиль</a><!--появляется только у Человека в личном чате, а не Группы-->
						<a class="dropdown-item">Редактировать группу</a><!--в личном чате этого пунката нет, только для Групп-->
						<!--появляется у владельца канала-->
						<a class="dropdown-item">Покинуть группу</a><!--в личном чате этого пунката нет, только для Групп-->
					</base-dropdown>

					<base-button type="primary" class="no-border" simple icon>
						<i class="d-inline-block tim-ic ic-fullscreen"></i>
					</base-button>
					<base-button type="primary" class="no-border" simple icon>
						<i class="d-inline-block tim-icons icon-simple-remove"></i>
					</base-button>
				</div>

			</div><!--END header_container-->	

			<div class="chat_search">
					<base-input
					placeholder="Поиск"
					addon-left-icon="tim-icons icon-zoom-split"
					autocomplete="off"
					class="col-md"
					></base-input>
				<!--пока просто вставила импут, тут должен быть поиск чатов без дроплиста-->
				<button class="btn btn-icon btn-simple btn-danger">
					<i class="tim-icons icon-simple-remove"></i>
				</button>		
			</div>
			
		</div><!--END chat_header-->	

		<div class="chat_body mt-3">
			<ReChatMessage/>
			<ReChatMessage :src="'/img/bg1.jpg'" />
			<ReChatMessage :src="'/img/bg1.jpg'" />
		</div>

	
		<form class="chat_footer card position-sticky">
			<div class="chatReplay">
				<base-button type="primary" class="no-border mr-2" simple icon>
					<i class="d-inline-block tim-ic ic-chat-replay"></i><!--ответ на сообщение-->
				</base-button>
				<base-button type="primary" class="no-border mr-2" simple icon style="display: none;">
					<i class="d-inline-block tim-ic ic-chat-forward"></i><!--пересыл сообщения-->
				</base-button>
				<div class="replyMsg_wrapper">
					<div class="replybar"></div>
					<div class="col">
						<p class="userName mb-0 text-info">{{userName}}</p>
						<p class="comText">{{comText}}</p><!--{{comment.comText}}-->
					</div>
				</div>

				<base-button type="primary" class="no-border ml-auto" simple icon>
					<i class="d-inline-block tim-icons icon-simple-remove"></i>
				</base-button>

			</div>

			<div class="chatSend">
				<ReFileUpload type="file" @change="UploadFile" class="mr-3" />

				<div class="messageInp">            
					<el-input
					type="textarea"
					autosize
					placeholder="Написать сообщение"
					v-model="textarea1"
					></el-input>
				</div>
				<base-button class="btn btn-icon btn-simple btn-success ml-3">
					<i class="tim-icons icon-send"></i>
				</base-button>

			</div>
		</form><!--END chat_footer-->


	</div>
</template>

<script>
import { Input } from "element-ui";
import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReChatMessage from "src/our_components/ReChatMessage.vue";


export default {
	name: 'ReChatMain',
	components: {
		[Input.name]: Input,
		ReFileUpload,
		ReChatMessage,		
	},
	props: {
		counter: {
			type: String,
			default: '0',
		},
		findId: {
			type: String,
			default: '',
		},
		channelIcon: {
            type: String,
            default: "/img/icons/icon-channel.svg"
        },
        title: {
            type: String,
            default: "Название чата/ ФИО"
        },
        subtitle: {
            type: String,
            default: "Subtitle"
		},
		chatIsHidden: {
			type: Boolean,
			default: false
		},
		comText: {
            type: String,
            default: "Текст сообщения Текст сообщения Текст сообщения Текст сообщения"
		},
		userName: {
            type: String,
            default: "Имя Фамилия"
        },



	},
	data () {
		return {
			ver: 1,
			textarea1: "",
		}
	},
	computed: {
		/*
		strFIO: function(){
			return [this.objStaff.lastName,this.objStaff.firstName,this.objStaff.fatherName].join(' ');
		},
		bOnlineStatus: function(){
			if(this.objStaff.online == 1){
				return true;
			}
			return false;
		},
		strOnline: function(){
			if(this.bOnlineStatus){
				return 'онлайн';
			}else{
				return 'оффлайн';
			}
		}*/


	},
	methods: {
		UploadFile(files) {
      		this.$GVO
			.UploadFile("uploadForm", "UploadTaskHelp", {
			obj: "FileUpload",
			flt: { BP_ID: "1", id: "1" }
			})
			.then(objApi => {
			//console.log(objApi);
			if (objApi.success) {
				// console.log(objApi.data);
			}
			})
			.catch(errorObjApi => {
				console.error(errorObjApi);
			});
		},
		hideChat() {
			this.chatIsHidden = !this.chatIsHidden;
		}

	},
}
</script>

<style scoped>

.header_container {display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 10px;}
.position-sticky {
	position: sticky;
	z-index: 2;
}
.chat_header {top: 0;}
.chat_footer {bottom: 0;}
.chat_header, .chat_body, .all_chats {display: flex; flex-direction: column;}
.chat_data, .chat_nav, .leftpart {display: flex; align-items: center;} 
.chat_nav .btn, .chat_body .btn, .chat_search .btn, .chatSend .btn {margin-top: 0;}
.ReChatMain  .chatSrch {padding-left: 0;}
.chat-photo {margin-right: 15px; margin-left: 5px;}
.chat-photo img {max-width: unset;}
.chat-photo .avatar {
  min-width: 25px;
  min-height: 25px;
  margin-bottom: 0;
  background-color: transparent;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.title_row .title {display: flex; align-items: center;}
.title_row .title i {margin-right: 5px;}
.title_row .title p {overflow: hidden; max-height: 20px;  text-overflow: ellipsis;}

.onlineStatus > *{display: inline-block;}
.onlineStatus i{
	width: 7px;
	height: 7px;
	border-radius: 50%;
	margin-right: 5px;
}
.onlineStatus.online i{background-color: greenyellow;}
.onlineStatus.offline i{background-color: red;}

.chat_search {
	display: flex;
	width: 100%;
	border-bottom: 1px solid #2b3553;
	padding-bottom: 5px;
}
.favs .title {display: flex;}

.ReChatMain >>> .dropdown-menu {
  right: 0;
  top: 90%;
  left: auto;
}
.ReChatMain >>> .dropdown-menu::before {
  right: 10px;
  left: auto;
}
.chat_search .form-group.col-md {padding-left: 0;}


/*===chat_footer============================*/

.chat_footer.card {	
	display: flex;	
	flex-direction: column;
	border-top: 1px solid #2b3553;
	padding-top: 10px;
}
.chat_footer.card, .chat_header.card {	
	width: 100%;
	box-shadow: none;
	margin-bottom: 0;
	border-radius: 0;
}
.messageInp {
	display: flex;	
	width: 100%;
	height: auto;
}
.chatSend {display: flex; margin-top: 10px;}
.chatReplay {
	display: flex;
	margin: 2px;
	overflow: hidden;
	color: inherit;
	text-decoration: none;
	border-bottom: 1px solid #2b3553;
	padding-bottom: 5px;
}
.replyMsg_wrapper {
	position: relative;
	display: flex;
	overflow: hidden;
    max-height: 45px;
}
.replybar {
	background: linear-gradient(180deg, #01B0E0 0%, #00DCB1 100%) !important;
    height: 85%;
    width: 2px;
    position: absolute;
}

/*===textarea===============================*/
.chatSend textarea.form-control {
  padding: 10px;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  max-height: none;
  height: auto;
  line-height: inherit;
}
.chatSend textarea.form-control:focus {
  border-color: #01b0e0;
}

.chatSend >>> .el-textarea__inner {
  height: 38px;
  resize: none;
  background-color: transparent;
  border: 1px solid #2b3553;
  border-radius: 0.4285rem;
  font-size: 0.75rem;
  padding: 10px;  
}
.chatSend >>> .el-textarea__inner:focus {
  border-color: #01b0e0;
}
.chatSend >>> .el-textarea__inner::placeholder {color: inherit;}

@media (max-width: 767px) {
	.header_container {margin-top: 10px;}	
}
</style>
